import React, { useEffect, useState } from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import "components/ToastContainer/index.scss";

import XOutlineRegularIcon from "assets/SVGComponents/XOutlineRegularIcon";
import {
  CheckCircleOutlineFillIcon,
  WarningOutlineFillIcon
} from "assets/SVGComponents/index";

const iconMap = {
  success: <CheckCircleOutlineFillIcon />,
  danger: <WarningOutlineFillIcon />,
  warning: <WarningOutlineFillIcon />
};

// Global toast trigger
let triggerToastFn = null;

export const showToast = (message, variant = "info") => {
  if (triggerToastFn) {
    triggerToastFn(message, variant);
  } else {
    console.warn("Toast container not mounted yet.");
  }
};

const CustomToastContainer = () => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const [variant, setVariant] = useState("info");

  useEffect(() => {
    // Register this toast function globally
    triggerToastFn = (msg, type) => {
      setMessage(msg);
      setVariant(type);
      setShow(true);
    };

    // Cleanup on unmount
    return () => {
      triggerToastFn = null;
    };
  }, []);

  if (!show) return null;

  return (
    <div className="toast-wrapper">
      <ToastContainer position="top-end" className="p-0">
        <Toast
          bg={variant}
          show={show}
          onClose={() => setShow(false)}
          delay={4000}
          autohide
          className={`custom-toast ${variant}`}
        >
          <Toast.Body className="text-white d-flex align-items-center gap-2">
            {iconMap[variant]}
            <span className={`${variant}`}>{message}</span>

            <div onClick={() => setShow(false)} className="close-icon">
              <XOutlineRegularIcon color="#797979" />
            </div>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default CustomToastContainer;
